import React, { FC, useCallback, useState } from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import {
  RATE_OFFER_FORM_NAME,
  RateOfferFormFields,
  RateOfferFormValues,
  validateRateForm,
} from './rate-offer-form.logic';
import { formButtonModalLayout, FormContainer } from 'components/form-container/form-container';
import { Text } from 'components/text/Text';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Stack } from 'components/stack/stack';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { offerSlice } from 'logic/store/offer/offer.slice';
import { RateButton } from './rate.button';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { FormTextInput } from 'components/form-inputs/form-text-input/form-text-input';
import { StarsRating } from 'components/rating/StarsRating';
import { useCurrentOffer } from 'logic/hooks/useCurrentOffer';
import { useTutorInfo } from '../../useTutorInfo';

const StarsWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  width: ${({ minTablet }) => (minTablet ? '230px' : '100%')};
`;
const ReasonWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  width: ${({ minTablet }) => (minTablet ? '265px' : '100%')};
`;

const RateOffer: FC = () => {
  const dispatch = useDispatch();
  const { minTablet } = useBreakpoints();
  const { offer, offerId } = useCurrentOffer();
  const { tutorNameLabel, city } = useTutorInfo({ offer });
  const formValues: RateOfferFormValues | undefined = useSelector(
    getFormValues(RATE_OFFER_FORM_NAME)
  );
  const [stars, updateStars] = useState(0);
  const handleRateOffer = useCallback(() => {
    formValues?.reason &&
      stars !== 0 &&
      dispatch(
        offerSlice.actions.rateOffer({ offerId, comment: formValues.reason, rating: stars })
      );
  }, [dispatch, formValues, offerId, stars]);

  const isReportButtonDisabled =
    formValues?.reason === undefined || stars === 0 || formValues?.reason === null;

  return (
    <FormContainer style={{ padding: minTablet ? '0 70px' : '' }}>
      <Stack flow={'row'} gap={minTablet ? 2 : 0.5}>
        <Stack flow={minTablet ? 'column' : 'row'} gap={3} alignItems="start">
          <StarsWrapper minTablet={minTablet}>
            <Text size={minTablet ? 18 : 16} style={{ marginBottom: minTablet ? 16 : 19 }}>
              {tutorNameLabel} {city}
            </Text>
            <StarsRating
              onChange={(value: number) => {
                updateStars(value);
              }}
              allowChange
              size={33}
              spaceStars={12}
              value={stars}
            />
            <Text
              color="black"
              size={14}
              fontWeight={800}
              style={{ marginTop: '30px', maxWidth: '100%' }}
            >
              {translate(translationKeys.rateTooltips[stars])}
            </Text>
          </StarsWrapper>
          <ReasonWrapper minTablet={minTablet}>
            <Text size={minTablet ? 18 : 16} style={{ marginBottom: minTablet ? 16 : 19 }}>
              {translate(translationKeys.rateTooltips.reasonTitle)}
            </Text>
            <Field
              name={RateOfferFormFields.reason}
              component={FormTextInput}
              isTextArea
              autoSize={{ minRows: 4, maxRows: 6 }}
              className="formRating"
              style={{ fontSize: minTablet ? '16px' : '14px' }}
              placeholder={translate(translationKeys.rateTooltips.placeholder)}
              required
              {...formButtonModalLayout}
            />
          </ReasonWrapper>
        </Stack>
        <RateButton onClick={handleRateOffer} disabled={isReportButtonDisabled} />
      </Stack>
    </FormContainer>
  );
};

export const RateOfferForm = reduxForm({
  form: RATE_OFFER_FORM_NAME,
  validate: validateRateForm,
})(RateOffer);
